import qs, { parse } from 'query-string';

import { getWindowLocationSearch } from '../window';

export const getAll = () => parse(getWindowLocationSearch());

export const getByName = (name: string, defaultValue = '') => {
  const params = getAll();

  return params[name] || defaultValue;
};

export const stringify = (object: any) => qs.stringify(object, { sort: false });

export const addQueryParam = (search: string, param: string, value: any) => {
  const parsedSearch = qs.parse(search, { sort: false });
  // @ts-ignore TODO_TYPES: ?
  parsedSearch[param] = value;
  return qs.stringify(parsedSearch, { sort: false });
};

export const removeQueryParam = (search: string, param: string) => {
  const parsedSearch = qs.parse(search, { sort: false });
  // @ts-ignore TODO_TYPES: ?
  delete parsedSearch[param];
  return qs.stringify(parsedSearch, { sort: false });
};
